


































































































































































































































import IPerson from '@/store/models/IPerson';
import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import ICompany from '@/store/models/ICompany';
import IRole from '@/store/models/IRole';
import IRolePermission from '@/store/models/IRolePermission';
import { EMPTY_GUID } from '@/config/constants';

@Component({
    components: {
        Snackbar
    }
})
export default class PersonSelector extends Vue {
    searchPerson: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name', value: 'name' },
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'Prefix', value: 'prefix' },
        { text: 'Phone Number', value: 'phoneNumber' },
        { text: 'Email', value: 'email' },
        { text: 'Company', value: 'company' },
        { text: 'UserName', value: 'userName' },
        { text: 'Role', value: 'roleName' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IPerson = {
        id: "",
        name: "",
        firstName: "",
        lastName: "",
        idListPhonePrefix: "",
        prefix: "",
        phoneNumber: "",
        email: "",
        idCompany: "",
        companyName: "",
        idUser: "",
        userName: "",
        password: "",
        idRole: "",
        roleName: ""
    }
    defaultItem :IPerson = {
        id: "",
        name: "",
        firstName: "",
        lastName: "",
        idListPhonePrefix: "",
        prefix: "",
        phoneNumber: "",
        email: "",
        idCompany: "",
        companyName: "",
        idUser: "",
        userName: "",
        password: "",
        idRole: "",
        roleName: ""
    }

    @Prop({ type: Array, required: true })
    PersonList !: IPerson[];
    @Prop({ type: Array, required: true })
    ListPhonePrefix !: IListPhonePrefix[];
    @Prop({ type: Array, required: true })
    CompanyList !: ICompany[];
    @Prop()
    IdCompany !: string;
    @Prop({ type: Array, required: true })
    RoleList !: IRole[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop()
    value !: IPerson;
    
    selectedRole: any = null;
    selectedPerson : IPerson[] = [];
    selectedPhonePrefix: any = null;
    selectedCompany: any = null;
    phonePrefixCountry : string[] = [];
    showPassword: boolean = false;
    password: string = "";

    get ListPhonePrefixesSort () {
        return [...this.ListPhonePrefix].sort((a, b) => a.prefix.localeCompare(b.prefix));
    }

    get isSuperAdmin() {
        return this.IdCompany === EMPTY_GUID;
    }

    get formTitle() { return this.editedIndex === -1 ? 'New User' : 'Edit User'; }

    get sortedRoleList() {
        return [...this.RoleList].sort((a, b) => a.roleName.localeCompare(b.roleName));
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    @Watch('value')
    updateSelection(newValue : IPerson | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedPerson = [];
        } else {
            this.selectedPerson = [newValue];
        }
    }

    resetPerson() {
        this.selectedPhonePrefix = [];
        this.selectedRole = [];
        this.selectedPerson = [];
        this.password = "";
        this.$emit('resetPerson');
    }

    editPerson (item: any, dbox = true) {
        if (this.selectedPerson.length > 0) {
            this.editedIndex = this.PersonList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.password = "";
            this.selectedCompany = this.CompanyList.find(p => p.id === this.editedItem.idCompany);
            this.selectedPhonePrefix = this.ListPhonePrefix.find(p => p.id === this.editedItem.idListPhonePrefix);
            this.selectedRole = this.RoleList.find(r => r.roleName === this.editedItem.roleName);
            this.dialog = true;
        }
    }

    savePerson (person: IPerson) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.setCountryPrefix();
            this.setSelectedCompany();
            this.setRole();
            this.editedItem.password = this.password;
            if (this.editedIndex > -1 || this.selectedPerson[0]) {
                if (this.isValidPassword()) {
                    this.$emit('editPerson', this.editedItem);
                    Object.assign(this.PersonList[this.editedIndex], this.editedItem);
                }
            } else {
                this.$emit('savePerson', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    isValidPassword() {
        let isValid : boolean = true;
        if (this.editedItem.password !== "") {
            if (this.editedItem.password.length < 8) {
                this.showMessageWarning('Use 8 characters or more for your password');
                isValid = false;
            } else if (this.editedItem.password.length < 5) {
                this.showMessageWarning('Password must have 5+ characters');
                isValid = false;
            } else if (!this.editedItem.password.match(/(?=.*[A-Z])/)) {
                this.showMessageWarning('Must have one uppercase character');
                isValid = false;
            } else if (!this.editedItem.password.match(/(?=.*\d)/)) {
                this.showMessageWarning('Must have one number');
                isValid = false;
            } else if (!this.editedItem.password.match(/([!@$%])/)) {
                this.showMessageWarning('Must have one special character [!@#$%]');
                isValid = false;
            }
        }
        return isValid;
    }

    deletePerson (person: IPerson) {
        if (this.selectedPerson.length > 0) {
            this.$emit('deletePerson', person);
            this.close();
        }
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }
    
    setRole() {
        if (this.selectedRole) {
            let role : any = this.RoleList.find(r => r.roleName === this.selectedRole.roleName);
            if (role) {
                this.editedItem.roleName = this.selectedRole.roleName;
                this.editedItem.idRole = this.selectedRole.id;
            }
        }
    }

    setSelectedCompany() {
        let company: any;
        if (this.selectedCompany) {
            company = this.CompanyList.find(c => c.name === this.selectedCompany.name);
        } else {
            company = this.CompanyList.find(c => c.id === this.IdCompany);
        }
        if (company) {
            this.editedItem.idCompany = company.id;
            this.editedItem.companyName = company.name;
        }
    }

    setCountryPrefix() {
        if (this.selectedPhonePrefix) {
            let phonePrefix: IListPhonePrefix = this.ListPhonePrefix.find(p => p.country === this.selectedPhonePrefix.country)!;
            if (phonePrefix) {
                this.editedItem.idListPhonePrefix = phonePrefix.id;
                this.editedItem.prefix = phonePrefix.prefix;
            }
        }
    }

    select(item : IPerson) : void {
        let index : number = this.selectedPerson.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedPerson = [item];
            this.$emit('input', item);
        } else {
            let person = this.selectedPerson.find(w => w.id === item.id);
            if (!person) {
                this.selectedPerson = [];
                this.$emit('input', null);
            }
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
